// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-container[data-v-64262db5]{position:relative;overflow:hidden;width:100%;padding-top:56.25%}iframe[data-v-64262db5]{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;border-radius:1rem}", ""]);
// Exports
module.exports = exports;
